export default `
mutation CreateDivision($divisionId: ID!, $serviceProviderId: ID!, $displayName: String!) {
  createDivision(divisionId: $divisionId, serviceProviderId: $serviceProviderId, displayName: $displayName) {
    divisionId
    displayName
    updatedAt
    serviceProviderId
    isDeleted
  }
}
`;